export const initialState = {
  loading: true,
  cycles: [],
};

export const executionsReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_CYCLES_START":
      return { ...state, loading: true };

    case "FETCH_CYCLES_SUCCESS":
      return { loading: false, cycles: action.payload };

    case "FETCH_EXECUTIONS_START":
      return {
        ...state,
        cycles: state.cycles.map(c =>
          c.cycleId === action.cycleId
            ? { ...c, loading: true }
            : c
        ),
      };

    case "FETCH_EXECUTIONS_SUCCESS":
      return {
        ...state,
        cycles: state.cycles.map(c =>
          c.cycleId === action.cycleId
            ? {
                ...c,
                executions: [...c.executions, ...action.payload],
                executionsLoaded: true,
                loading: false,
                pagination: {
                  ...c.pagination,
                  offset: c.pagination.offset + action.payload.length,
                  hasMore: action.payload.length > 0,
                },
              }
            : c
        ),
      };

    default:
      return state;
  }
};